import { createContext, useContext } from "react";
import type { WebModule } from "./module.ts";

/**
 * Every module's web half, for the few places one module draws what others
 * add to it (the rows in a creator's hero). A module cannot import the
 * registry, which imports it, so the app hands the list down from the top.
 */
const ModulesContext = createContext<WebModule[]>([]);

export const WebModulesProvider = ModulesContext.Provider;

export function useWebModules(): WebModule[] {
  return useContext(ModulesContext);
}
